/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import Chart from 'react-apexcharts';

import { Grid, Button, LinearProgress } from '@material-ui/core';
import { KeyboardDateTimePicker } from '@material-ui/pickers';
import moment from 'moment';

import { Dialog } from '~/components';
import { t, timestampToDate } from '~/helpers';
import api from '~/services/api';

import { Container, Graph } from './styles';

class Graphic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loading: false,
      params: {},
      options: {},
      series: [],
      format: 'DD/MM/YYYY HH:mm:ss',
      dateTimeInitial: moment().hours(0).minute(0).second(0).format(),
      finalDateTime: moment().hours(23).minute(59).second(59).format(),
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    const { open } = this.state;

    if (!open) {
      this.setState(
        {
          open: true,
          params,
        },
        () => {
          if (!open) {
            this.handleParamsGraphic();
          }
        }
      );
    } else {
      this.setState({
        params: {},
        options: {},
        series: [],
        open: false,
        dateTimeInitial: moment().hours(0).minute(0).second(0).format(),
        finalDateTime: moment().hours(23).minute(59).second(59).format(),
      });
    }
  }

  // Search params alarms
  async handleParamsGraphic(params = {}) {
    try {
      this.setState({ loading: true });

      const { dateTimeInitial, finalDateTime } = this.state;
      const datahorainicio = moment(dateTimeInitial).format(
        'YYYY-MM-DD HH:mm:ss'
      );
      const datahorafim = moment(finalDateTime).format('YYYY-MM-DD HH:mm:ss');
      const { idposto, idtanquefisico } = this.state.params.graphic;

      const { data } = await api.get('historicosmedicoestanques', {
        params: {
          idposto,
          idtanque: idtanquefisico,
          ...params,
          datahorainicio,
          datahorafim,
          pageSize: 99999,
        },
      });

      const item = this.serializeObject(data);

      this.setState({ options: item.options, series: item.series });
    } catch (e) {
      console.tron.log(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  // Serialize params graphics
  serializeObject(obj) {
    const categories = [];
    const volume = [];
    const temperature = [];
    const height = [];

    obj.map((row) => {
      categories.push(timestampToDate(row.datahistoricomedicao, true));
      volume.push(row.volumenivel1historicomedicao);
      temperature.push(row.temperaturamediahistoricomedicao);
      height.push(row.alturanivel1historicomedicao);

      return true;
    });

    return {
      series: [
        { name: t('s.global.volume'), type: 'line', data: volume },
        {
          name: t('s.operacao.estoque.temperatura'),
          type: 'line',
          data: temperature,
        },
        {
          name: t('s.relatorio.descarganf.altura'),
          type: 'line',
          data: height,
        },
      ],
      options: {
        chart: {
          type: 'line',
          stacked: false,
          animations: { enabled: false },
        },
        dataLabels: { enabled: false },
        stroke: {
          width: [4, 4, 4],
        },
        xaxis: { categories },
        yaxis: [
          {
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#008FFB' },
            labels: {
              style: {
                colors: '#008FFB',
              },
            },
            title: {
              text: t('s.relatorio.afericao.volume'),
              style: {
                color: '#008FFB',
              },
            },
            tooltip: { enabled: true },
            min: 0,
          },
          {
            seriesName: t('s.operacao.estoque.temperatura'),
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#00E396' },
            labels: {
              style: {
                colors: '#00E396',
              },
            },
            title: {
              text: t('s.operacao.estoque.temperatura'),
              style: {
                color: '#00E396',
              },
            },
            min: 0,
          },
          {
            seriesName: t('s.relatorio.descarganf.altura'),
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: '#FEB019' },
            labels: {
              style: {
                colors: '#FEB019',
              },
            },
            title: {
              text: t('s.relatorio.descarganf.altura'),
              style: {
                color: '#FEB019',
              },
            },
            min: 0,
          },
        ],
        legend: {
          horizontalAlign: 'left',
          offsetX: 40,
        },
      },
    };
  }

  render() {
    const {
      options,
      series,
      open,
      params,
      dateTimeInitial,
      finalDateTime,
      format,
      loading,
    } = this.state;

    return (
      <Dialog
        open={open}
        title={params.tafi_codigo}
        toggle={() => this.handleToggleModal()}
      >
        {loading && <LinearProgress />}

        <Grid container spacing={3} alignContent="center">
          <Grid item sm={12} md={9} lg={10}>
            <Container>
              <Graph>
                <Chart
                  height="100%"
                  options={options}
                  series={series}
                  type="line"
                />
              </Graph>
            </Container>
          </Grid>

          <Grid item sm={12} md={3} lg={2}>
            <Container>
              <KeyboardDateTimePicker
                ampm={false}
                format={format}
                fullWidth
                id="date-picker-initial"
                label={t('s.geral.opcoes.datahorainicial')}
                margin="normal"
                onChange={(value) => this.setState({ dateTimeInitial: value })}
                required
                value={dateTimeInitial}
                disabled={loading}
              />

              <KeyboardDateTimePicker
                ampm={false}
                format={format}
                fullWidth
                id="date-picker-final"
                label={t('s.geral.opcoes.datahorafinal')}
                margin="normal"
                onChange={(value) => this.setState({ finalDateTime: value })}
                required
                value={finalDateTime}
                disabled={loading}
              />

              <Button
                color="primary"
                onClick={() => this.handleParamsGraphic()}
                variant="contained"
                disabled={loading}
              >
                {t('c.global.filtrar')}
              </Button>
            </Container>
          </Grid>
        </Grid>
      </Dialog>
    );
  }
}

export default Graphic;
